import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Main from './main';
import results from './sections/results';

export default (
  <Route path="signup-earn">
    <IndexRoute component={(props) => <Main {...props} />} />
    <Route path=":id/:action">
      <IndexRoute component={(props) => <Main {...props} />} />
    </Route>
    <Route path="resultados" component={results} />
  </Route>
);
